import * as React from 'react';
import {SCREENS, WP_CONTENT_PREFIX, THIRD_PAGE} from '../../constants';
import {Background} from '../../styled-components/Background';
import {PlotArea, PlotAreaMargin, PlotAreaWrapper} from '../../styled-components/PlotAreaComps';
import {FloatingCloud} from '../../styled-components/FloatingCloud';
import {Relative} from '../../styled-components/Relative';
import {StatusBar} from '../StatusBar';
import {Cloud} from '../../styled-components/Cloud';
import styled from 'styled-components';
import {analyticsEvent, sendGAEventToExtension} from '../../utils/analytics';
import VisibilitySensor from "react-visibility-sensor";
import {GestureGif, GroundInfo, InfoTitle} from "../GroundInfo";
import {Title} from "../../styled-components/Title";
import I18n from '../../utils/i18n';
import ReactHtmlParser from 'react-html-parser';
import {HelpOverlay} from "../HelpOverlay";
import BouncePrevention from "../../utils/BouncePrevention";
import {BounceOverlay} from "../BounceOverlay";

const Castle = styled.img`
    height: 25vh;
    margin-top: 10vh;
    position: relative;
    top: 0;
    left: 0;
    z-index: 2;
`;

const Princess = styled.img`
    height: 10vh;
    position: absolute;
    top: 2vh;
    left: 17vw;
    z-index: 1;
`;

const PrincessArrow = styled.img`
    height: 4vh;
    position: absolute;
    top: -3vh;
    left: 20.3vw;
`;

const Mouse = styled.img`
    height: 10vh;
    margin-top: 25vh;
`;

const Overlay = styled.div`
    position: fixed;
    height: 100vh;
    width: 100vw;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 4;
    display: flex;
    justify-content: center;
    align-items: center;
    
    a {
    text-decoration: none;
    }
`;

const CTA = styled.div`
    background: url('${`${WP_CONTENT_PREFIX}/images/end-game.svg`}');
    &:hover {
        background: url('${`${WP_CONTENT_PREFIX}/images/end-game-hover.png`}');
    }
    width: 670px;
    height: 132px;
    cursor: pointer;
    font-size: 30px;
    color: #000000;
    line-height: 132px;
    text-align: center;
    font-family: 'Pixel Coleco';
`;


export class FifthScreen extends React.Component {

    constructor(){
        super();
        this.OVERLAY_TYPES = {
            help: 'help',
            bounce: 'bounce'
        };
        this.state = {
            showHelpOverlay: false,
            showBounceOverlay: false,
            currentOverlay: null
        };
        this.ctaClicked = this.ctaClicked.bind(this);
        this.onVisible = this.onVisible.bind(this);
        this.closeHelpOverlay = this.closeHelpOverlay.bind(this);
        this.closeBounceOverlay = this.closeBounceOverlay.bind(this);
        this.renderOverlays = this.renderOverlays.bind(this);
    }

    ctaClicked() {
        analyticsEvent('Onboarding',
            'Screen 5',
            'CTA Clicked'
        );
    }

    onVisible(isVisible) {
        if(isVisible) {
            BouncePrevention.startObserving(() => {
                this.setState({
                    showHelpOverlay: true
                });
            });
            BouncePrevention.startBouncePrevention(() => {
                this.setState({
                    showBounceOverlay: true
                })
            });
            analyticsEvent('Onboarding',
                'Screen 4',
                'Scroll up'
            );
            analyticsEvent('Onboarding',
                'Screen 5',
                'Shown'
            );
            const currentScreen = 5;
            history.pushState({screen: currentScreen}, "", `?screen=${currentScreen}`);
            const heartFullToAnimate = document.querySelector('#full-5');
            heartFullToAnimate.classList.add("animation-heart-full");
            const heartHalfFullToAnimate = document.querySelector('#half-full-5');
            heartHalfFullToAnimate.classList.add("animation-heart-half-empty");
            sendGAEventToExtension('Onboarding', 'Screen 5', 'Shown');
        }
    }

    closeHelpOverlay() {
        this.setState({
            showHelpOverlay: false
        });
    }

    closeBounceOverlay() {
        this.setState({
            showBounceOverlay: false
        });
    }

    renderOverlays() {
        const {currentOverlay} = this.state;

        if (currentOverlay === this.OVERLAY_TYPES.help) {
            return <HelpOverlay closeHelpOverlay={this.closeHelpOverlay} screen={SCREENS.fifth} />
        } else if (currentOverlay === this.OVERLAY_TYPES.bounce) {
            return <BounceOverlay screen={SCREENS.fifth} closeBounceOverlay={this.closeBounceOverlay} />
        } else {
            return null;
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        const {showHelpOverlay, showBounceOverlay} = this.state;

        // hide help overlay
        if (showHelpOverlay && !nextState.showHelpOverlay) {
            this.setState({
                showBounceOverlay: false,
                currentOverlay: null
            });
            // show help overlay
        } else if (!showHelpOverlay && nextState.showHelpOverlay) {
            this.setState({
                currentOverlay: showBounceOverlay ? this.OVERLAY_TYPES.bounce : this.OVERLAY_TYPES.help
            });
        }
        // hide bounce overlay
        if (showBounceOverlay && !nextState.showBounceOverlay) {
            this.setState({
                showHelpOverlay: false,
                currentOverlay: null
            });
            // show bounce overlay
        } else if (!showBounceOverlay && nextState.showBounceOverlay) {
            this.setState({
                currentOverlay: showHelpOverlay ? this.OVERLAY_TYPES.help : this.OVERLAY_TYPES.bounce
            });
        }
        return true;
    }

    componentDidUpdate(prevProps) {
        const {finishedDownloading} = this.props;
        if(!prevProps.finishedDownloading && finishedDownloading) {
            analyticsEvent('Onboarding',
                'Screen 5',
                'CTA Shown'
            );
        }
    }

    render() {
        const {finishedDownloading, toggleMusicPlaying, musicPlaying} = this.props;
        return (
            <React.Fragment>
                {finishedDownloading ? <Overlay>
                        <a href={THIRD_PAGE} onClick={this.ctaClicked}>
                            <CTA>
                                {I18n.translate('fifthFinishGame')}
                            </CTA>
                        </a>
                </Overlay> : null}
                <Background>
                    {this.renderOverlays()}
                    <PlotAreaWrapper>
                        <StatusBar screen={SCREENS.fifth} toggleMusicPlaying={toggleMusicPlaying} musicPlaying={musicPlaying}/>
                        <Title verticalAlign='top'>{I18n.translate('gestureInstructions5')}</Title>
                        <PlotArea>
                            <PlotAreaMargin margin='5vw' />
                            <Cloud src={`${WP_CONTENT_PREFIX}/images/cloud.png`} marginTop='7vh' />
                            <Relative>
                                <Castle src={`${WP_CONTENT_PREFIX}/images/castle.png`} />
                                <PrincessArrow src={`${WP_CONTENT_PREFIX}/images/link_arrow.gif`} />
                                <Princess src={`${WP_CONTENT_PREFIX}/images/Princess_in_distress.gif`} />
                                <FloatingCloud src={`${WP_CONTENT_PREFIX}/images/cloud.png`} top='9vh' left='-1vw'/>
                                <FloatingCloud src={`${WP_CONTENT_PREFIX}/images/cloud.png`} top='-2vh' left='2vw'/>
                                <FloatingCloud src={`${WP_CONTENT_PREFIX}/images/cloud.png`} top='9vh' left='21vw'/>
                            </Relative>
                            <Cloud src={`${WP_CONTENT_PREFIX}/images/cloud.png`} marginTop='1vh' />
                            <Mouse src={`${WP_CONTENT_PREFIX}/images/static_mouse.png`} />
                            <Cloud src={`${WP_CONTENT_PREFIX}/images/cloud.png`} marginTop='1vh' />
                        </PlotArea>
                    </PlotAreaWrapper>
                        <GroundInfo extensionInstalled={true} screen={SCREENS.fifth}>
                            <React.Fragment>
                                <VisibilitySensor onChange={this.onVisible}>
                                    <InfoTitle marginTop="4vh" fontSize="2vh"> *** {I18n.translate('gameReference5')} ***</InfoTitle>
                                </VisibilitySensor>
                                <InfoTitle marginTop="3vh">{ReactHtmlParser(I18n.translate('movementInstructions5'))}</InfoTitle>
                                <GestureGif src={`${WP_CONTENT_PREFIX}/images/super_down.gif`}></GestureGif>
                            </React.Fragment>
                        </GroundInfo>
                </Background>
            </React.Fragment>
        );
    }
}
